import { Component } from '@angular/core';
import { FooterComponent } from "../footer/footer.component";
import { HeaderComponent } from '../header/header.component';
import { HttpClient,HttpClientModule, HttpHeaders,} from '@angular/common/http';
import { ApidataService } from '../apidata.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import swal from "sweetalert2";
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment, GINConstants } from '../../environments/environments';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl, FormGroupDirective, NgForm } from '@angular/forms';
import { RecaptchaModule, RECAPTCHA_SETTINGS } from 'ng-recaptcha';

declare var google: any;
declare var gapi: any;
declare var $: any;
@Component({
  selector: 'app-signupwithcard',
  standalone: true,
  imports: [FooterComponent, HeaderComponent,HttpClientModule,CommonModule,ReactiveFormsModule,RouterModule,
    RecaptchaModule,
   ],
  templateUrl: './signupwithcard.component.html',
  styleUrl: './signupwithcard.component.css',
  providers: [ApidataService]
})
export class SignupwithcardComponent {
  constructor(
    private router: Router,

    private httpClient: HttpClient,private apirequest:ApidataService

  ) {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  emptyFields = [];
  isUserLoggedin : boolean = false;
  authentication_token;
  user;
  idgoogle;
  pass;
  price_id;
  logins;
  login;
  public nodata: boolean = false;
  profile_id;
  form_firstname: any;
  form_lastname: any;
  form_email: any;
  form_password;
  dangerAlerts2;
  selectedplan;
  selectedplanamount ='';
  color;
  form_captcha;
  selectedprice_id;

  captchaResponse: string;
  recaptchaSiteKey = '6LcMnOsnAAAAAExxnt0IqIEq4pSha6O_vPeOsw-1';
  recaptcha_message: string = "";
  passwordFieldType: string = 'password';
  emailerror: boolean = false;
  reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  color1;
  fieldIf: boolean = false;
  dangerAlerts;
  validations: boolean = false;
  ngOnInit() {
    
    this.profile_id = localStorage.getItem("profile_id");
 
    this.selectedplan = localStorage.getItem('plan');
    this.selectedplanamount = localStorage.getItem('amount');
   
    this.selectedprice_id =     localStorage.getItem('price_id')

    $(document).on('click', '.toggle-password2', function () {
      $(this).toggleClass('fa-eye fa-eye-slash');

      var input = $('#pass_log_id5');
      input.attr('type') === 'password'
        ? input.attr('type', 'text')
        : input.attr('type', 'password');
    });


      this.logins = new FormGroup({
        login_email: new FormControl(),
        login_password : new FormControl()
    });

    this.loadTurnstileScript().then(() => this.renderTurnstile())


  }

  onFocus() {
    this.validations = true;
 
  }
  public checkEmptyFields(form) {
    let emptyFields = [];

    if (form.form_firstname === '') {
      emptyFields.push('firstname');
    }
    if (form.form_lastname === '') {
      emptyFields.push('lastname');
    }
    if (form.form_email === '') {
      emptyFields.push('email');
    }
    if (form.form_password === '') {
      emptyFields.push('pass_log_id5');
    }

    return emptyFields;
  }

error: boolean = false;
errorAlerts;
success: boolean = false;
successAlert;
resendEmail: boolean = false;
send;
sendEmail(message, selector){
  this.send = message;
  $(selector).css('border-color', 'red');
  this.resendEmail = true;
  $('#errorAlerts;').show();
  setTimeout(() => {
    $('#errorAlerts;').hide();
    $(selector).css('border-color', '#e7e7ec');
    this.resendEmail = false;
  }, 4000);
  let backdrop = document.querySelector('.modal-backdrop');
  if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      document.body.appendChild(backdrop); 
  }
}
showAlert(message, selector) {


  this.errorAlerts = message;
  $(selector).css('border-color', 'red');
  this.error = true;
  $('#errorAlerts;').show();
  setTimeout(() => {
    $('#errorAlerts;').hide();
    $(selector).css('border-color', '#e7e7ec');
    this.error = false;
  }, 4000);
  let backdrop = document.querySelector('.modal-backdrop');
  if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show'; 
      document.body.appendChild(backdrop); 
  }
}

showSuccess(message, selector) {
  this.successAlert = message;
  this.success = true;
  $('#successAlert').show();
  setTimeout(() => {
    $('#successAlert').hide();
    $(selector).css('border-color', '#e7e7ec');
    this.success = false;
  }, 4000);
}

closeErrorDiv() {
  this.error = false; 
}
closesendDiv() {
  this.resendEmail = false; 

}
  resetForm() {
    $('#firstname').val('').css('border-color', '#e7e7ec');
    $('#lastname').val('').css('border-color', '#e7e7ec');
    $('#email').val('').css('border-color', '#e7e7ec');
    $('#pass_log_id5').val('').css('border-color', '#e7e7ec');
    $('#captcha').prop('checked', false).css('border-color', '#e7e7ec');
  }

  FormSubmission(event) {
    event.preventDefault();

    if (this.captchaToken) {
  

    this.got_recpatcha = false;
  } else {
    this.got_recpatcha = true;
  
    $('#dangerAlert').html('Captcha is not loaded. Please reload the page.');
    $('#dangerAlert').show();
    this.nodata = true;
    setTimeout(function () {
      $('#dangerAlert').hide();
    }, 3000);
  
    return
  }

    this.fieldIf = false;
    $('#dangerAlerts').hide();

    this.form_firstname = $('#firstname').val();
    this.form_lastname = $('#lastname').val();
    this.form_email = $('#email').val();
    this.form_password = $('#pass_log_id5').val();
    this.form_captcha = $('#captcha').is(':checked');

    let form = {
      form_firstname: this.form_firstname,
      form_lastname: this.form_lastname,
      form_email: this.form_email,
      form_password: this.form_password,
 
    };
    let emptyFields = this.checkEmptyFields(form);
    if (emptyFields.length > 0) {
      this.showAlert("Please provide the required fields","")
    }
    else if (
      typeof this.form_email === 'string' &&
      this.reg.test(this.form_email) === false
    ) {
      this.showAlert("Please provide correct Email","#email")
    } else if (this.form_password === this.form_email) {
      this.showAlert("This password is too similar to your email address.Please choose another password","#pass_log_id5")

    }
   

  
     else {
      const headers = new HttpHeaders({
        Authorization: environment.AuthorizationGIN,
      });

      this.httpClient
        .post(
          environment.API_URL+'/api/signupFormProcesses',
          {

            firstname: this.form_firstname,
            lastname: this.form_lastname,
            email: this.form_email,
            password: this.form_password,
          },
          { headers }
        )
        .subscribe(
          (response) => {
         
            const userid = response['response'].user_id
            localStorage.setItem('signupid', response['response'].user_id);
    
             if ((response['meta'].code === 401) && (response['response']['errors'].signup_message === "You have verified your account. Please log in to use your account"))
               {
              this.showAlert("You have verified your account. Please log in to use your account.","");
            }
            else if ((response['meta'].code === 401) && (response['response']['errors'].signup_message === "Sorry! this account already exists. Please log in from your social account"))
              {
             this.showAlert("Sorry! this account already exists. Please log in from your social account","");
           }
            else if (
             ( response['meta'].code === 401) &&
              (response['response']['errors'].signup_message ===
                'Please verify your account first.')
            ) {

              this.showAlert("Please verify your account first","");
            } else if (
              (response['meta'].code === 400) &&
             ( response['response']['errors'].signup_message ===
                'Sorry! this account already exists.')
            ) {

              this.showAlert("Sorry! this account already exists","");
            }  else if(
             ( response['meta'].code === 200) &&
             ( response['response'].signup_message ===
                "Account Created Successfully, Please Sign In to Continue")
            )
            {


              this.router.navigate(['/verify-account']);
          
              this.resetForm();
            }
          },
          (error) => {
            // console.error(error);
          }
        );
    }
  }
  ///////// signup with google
  private initializeGoogleAuth(): Promise<void> {
    return new Promise((resolve, reject) => {
      gapi.load('auth2', () => {
        gapi.auth2.init({
          client_id: '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com', 
        }).then(() => {
          resolve();
        }).catch((error) => {
          // console.error('Error initializing Google Auth', error);
          reject(error);
        });
      });
    });
  }
  public  googleLogin(): void {
    this.initializeGoogleAuth().then(() => {
      const googleAuth = gapi.auth2.getAuthInstance();
      googleAuth.signIn({ scope: 'profile email' }).then(googleUser => {
  
        this.onSignIn(googleUser);
      }).catch(error => {
        // console.error('Google Sign-In failed', error);
      });
    }).catch(error => {
      // console.error('Google API initialization failed', error);
    });
  }

  public onSignIn(googleUser): void {
    const profile = googleUser.getBasicProfile();
    const id_token = googleUser.getAuthResponse().id_token;
    const body = {
        firstname: btoa(profile.getGivenName()),
        lastname: btoa(profile.getFamilyName()),
        email: btoa(profile.getEmail())
    };


    this.gLogin(body);
  }
  public gLogin(body): void {
    this.apirequest.signupinGoogle2(body).subscribe(data => {
      if (data.meta.code === 200) {
        localStorage.setItem('currentUser', JSON.stringify(data));
        
        this.user = data['response'];
        this.authentication_token = this.user['user'].authentication_token;
        this.idgoogle = this.user['user'].id;
        localStorage.setItem('fullname',this.user['user'].verify)
        localStorage.setItem(this.idgoogle, 'profile_id');
        const user_id = this.user['user'].id;
        localStorage.setItem(this.user['user'].authentication_token, 'token');
        
        localStorage.setItem(this.user['user'].authentication_token, 'authentication_token');
 
        localStorage.setItem('profile_id', this.idgoogle);
        localStorage.setItem('authentication_token', this.user['user'].authentication_token);
        localStorage.setItem('token', this.user['user'].authentication_token);

        localStorage.setItem('role', '1');
   
        const headers = new HttpHeaders({
          Authorization: environment.AuthorizationGIN,
        });
        var id= localStorage.getItem('price_id')
         this.apirequest.callpaymentapi(user_id, id).subscribe(data =>{
    
        if (data.meta.code == 403){
      
          swal({
            background: "#FFFFFF",
            html: `
              <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                <div class="text-center" style="margin-top: 9%;">
                  <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                  <div style="width: 323px; height: 64px; margin-left: 77px;">
                    <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                    ${data.response}
                    </p>
                  </div>

                  <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                    border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                    class="mt-4 butn-alert">Ok</button>
                </div>
              </div>
            `,
            showConfirmButton: false,
            width: "323px",
            timer: 4000
          });

    
          setTimeout(() => {
            const okButton = document.getElementById('swal-ok-button');
            if (okButton) {
              okButton.addEventListener('click', () => {
                swal.close(); 
              });
            }
          }, 0)

        }
        else if (data.meta.code == 400) {
      
          swal({
            background: "#FFFFFF",
            html: `
              <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                <div class="text-center" style="margin-top: 9%;">
                  <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                  <div style="width: 323px; height: 64px; margin-left: 77px;">
                    <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                    ${data.response}
                    </p>
                  </div>

                  <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                    border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                    class="mt-4 butn-alert">Ok</button>
                </div>
              </div>
            `,
            showConfirmButton: false,
            width: "323px",
            timer: 4000
          });

      
          setTimeout(() => {
            const okButton = document.getElementById('swal-ok-button');
            if (okButton) {
              okButton.addEventListener('click', () => {
                swal.close();
              });
            }
          }, 0)
        }
        else if (data.meta.code == 401) {
       
          swal({
            background: "#FFFFFF",
            html: `
              <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                <div class="text-center" style="margin-top: 9%;">
                  <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                  <div style="width: 323px; height: 64px; margin-left: 77px;">
                    <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                    ${data.response}
                    </p>
                  </div>

                  <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                    border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                    class="mt-4 butn-alert">Ok</button>
                </div>
              </div>
            `,
            showConfirmButton: false,
            width: "323px",
            timer: 4000
          });

   
          setTimeout(() => {
            const okButton = document.getElementById('swal-ok-button');
            if (okButton) {
              okButton.addEventListener('click', () => {
                swal.close(); 
              });
            }
          }, 0)
        }
        else{
          
         window.open(data['url'], '_blank')
 
        }
      
       }
      )


      }
    }
 
  );
  }

  openlogin() {

    $('.bd-example-modal-lg').modal('show');  // Open modal
  }
  togglePasswordVisibility(): void {
    this.passwordFieldType =
      this.passwordFieldType === 'password' ? 'text' : 'password';
  }
  public eLogin() {
  if (this.captchaToken) {
    this.got_recpatcha = false;
  } else {
    this.got_recpatcha = true;
  
    $('#dangerAlert').html('Captcha is not loaded. Please reload the page.');
    $('#dangerAlert').show();
    this.nodata = true;
    setTimeout(function () {
      $('#dangerAlert').hide();
    }, 3000);
  
    return
  }

    let login_email = $('#login_email').val();
    let login_password = $('#login_password ').val();
    if(login_email === '' || login_password === ''){
     $('#dangerAlert').html("Please provide the required fields");
      $('#dangerAlert').show();
      this.nodata = true;
      setTimeout(function() { $("#dangerAlert").hide();

      }, 3000);
    }
    if(this.logins.valid){
    $('#dangerAlert').html("");
    $('#dangerAlert').hide();
    let remember_me = $('#remember_me').val();
    if ($("#remember_me").is(':checked')) {
      let checked = true;
    }

    let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

    if ((this.logins.value.login_email === '' || this.logins.value.login_password === '')) {
      $('#dangerAlert').html("Please provide the required fields");
      $('#dangerAlert').show();
    }


 if(reg.test(this.logins.value.login_email) === false ){
$('#dangerAlert2').html("Please provide a valid Email");
$('#dangerAlert2').show();
}

    else if (this.logins.value.login_email && this.logins.value.login_password ){
      $('#loginBtn').hide();
      $('#loginProcBtn').show();

      $('#dangerAlert').html("");
      $('#dangerAlert').hide();
      let body = JSON.stringify({
        email: this.logins.value.login_email,
        password: this.logins.value.login_password,
        remember_me: remember_me
      });

      this.apirequest.login(body)
        .subscribe(
          (data) => {
         this.pass= data.response;
        
          if (data.response['meta'].code === 200 ) {

            this.login = data;
           
            $('#login_email').val('');
            $('#login_password').val('');
            const userid=data.response['response']['user'].id;
            this.apirequest.callpaymentapi(userid, this.selectedprice_id).subscribe(
              (data) =>{
           

              if (data.meta.code === 403 || data.response =='You are already subscribed. Please cancel previous subscription before getting new Subscription.'){
                this.showAlert(data.response, "");
              }
              else if (data.meta.code === 400) {

                this.showAlert(data.response,"");
              }
              else if (data.meta.code === 401) {

                this.showAlert(data.response,"");
              }
              else{
          
           
               window.open(data['url'], '_blank')
          
              }

             }
        
          )

   

          }

          else if(data.response['meta'].code === 400 && data.response['response']['errors']['password']){
            $('#loginBtn').show();
            $('#loginProcBtn').hide();
            $('#dangerAlert2').html("Invalid password");
            $('#dangerAlert2').show();
            setTimeout(function() { $("#dangerAlert2").hide();

          }, 4000);


          }
          else if(data.response['meta'].code === 400 && data['response']['response']['errors']['email']){
            $('#loginBtn').show();
            $('#loginProcBtn').hide();
            $('#dangerAlert2').html("Specified user does not exist");
            $('#dangerAlert2').show();
            setTimeout(function() { $("#dangerAlert2").hide();

          }, 4000);

      
          }
          else if(data.response['meta'].code === 401 && data.response.meta.message){
            $('#loginBtn').show();
            $('#loginProcBtn').hide();
            $('#dangerAlert2').html("There's already a GrammarIn account associated with this email through a social sign-in method. Please choose a social provider above to sign in.");
            $('#dangerAlert2').show();
            setTimeout(function() { $("#dangerAlert2").hide();

          }, 4000);

          }
          else if(data.response.code === 401 && data.response.meta === 'Please verify your account first.'){
            $('#loginBtn').show();
            $('#loginProcBtn').hide();
            $('#dangerAlert2').html("Please verify your account first.");
            $('#dangerAlert2').show();
            setTimeout(function() { $("#dangerAlert2").hide();

          }, 4000);

      
          }
          else {
            $('#loginBtn').show();
            $('#loginProcBtn').hide();

            $('#dangerAlert2').html("Invalid Email / Password");
            $('#dangerAlert2').show();
            setTimeout(function() { $("#dangerAlert2").hide();

          }, 4000);
      
          }
        }

        );
      }
    }
  }
  navigateTosignup() {
    this.router.navigate(['/signup']);
  }


  showRowBanner: boolean = true;
  showLeftSection: boolean = false;


  showSignIn() {
    this.showRowBanner = false;
    this.showLeftSection = true;
  }


  showSignUp() {
    this.showRowBanner = true;
    this.showLeftSection = false;
  }
loadTurnstileScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof window['turnstile'] !== 'undefined') {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject('Failed to load Turnstile script');
    document.body.appendChild(script);
  });
}

renderTurnstile(): void {
  if (typeof window['turnstile'] !== 'undefined') {
    window['turnstile'].render('#recaptcha-container', {
      sitekey: environment.CaptchaKey, 
      size: 'normal', 
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
   
  } else {
    // console.error('Turnstile script not loaded.');
  }
}

  got_recpatcha : boolean = false;
  captchaToken: string | null = null;


onTurnstileSuccess(token: string): void {
  // console.log('Turnstile token received:', token);
  this.captchaToken = token; 
}

// Error callback when CAPTCHA fails
onTurnstileError(): void {
  // console.error('Turnstile error occurred.');
  this.captchaToken = null; 
}
  onCaptchaResolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
  }

}
